import React from 'react'
import {Row, Col, Nav, Accordion,} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import useAuth from '../../context/auth/useAuth'
import { Link, useLocation } from 'react-router-dom'
import Version from '../../version'


export default function MenuMultiSchool() {
    const { t } = useTranslation()
	const {client, logout} = useAuth()
	const location = useLocation()

	const isactiveProcessesActive = (path) => {
		let isActive = false

		if (location.pathname === '/multischool/activeprocesses') {
			isActive = true
		}
		
		if (/^\/multischool\/overviewprocess\/[a-zA-Z0-9]/.test(path)) {
			isActive = true
		}

		if (/^\/multischool\/overviewprocess\/[a-zA-Z0-9]+\/candidates$/.test(path)) {
			isActive = true
		}

		if (/^\/multischool\/overviewprocess\/[a-zA-Z0-9]+\/precandidates$/.test(path)) {
			isActive = true
		}

		return isActive
	}

	const isSchoolsManagementActive = (path) => {
		let isActive = false

		if (location.pathname === '/multischool/schools') {
			isActive = true
		}
		
		if (/^\/multischool\/schools\/[a-zA-Z0-9]/.test(path)) {
			isActive = true
		}

		if (/^\/multischool\/schools\/[a-zA-Z0-9]+\/edit$/.test(path)) {
			isActive = true
		}

		return isActive
	}

  	return (
		<>
			<Row>
				<Col xs='12' className='d-flex justify-content-center mt-3 mb-2'>
					<div className='avatar'>
						<div className="img-profile"></div>
					</div>
				</Col>
				<Col className='text-center'>
					{client?.email}
				</Col>
			</Row>
			<Row>
				<Col className='d-flex justify-content-center align-items-center gap-2'>
					<Link to="/" onClick={logout}>
						<i className="fa-solid fa-arrow-right-from-bracket color-primary"></i>
					</Link>
				</Col>
			</Row>
			<Row style={{marginTop: '100px'}}>
				<Col className='p-0'>
					<Nav className="flex-column">
						<Nav.Item>
							<Link to="/multischool/dashboard" className={`nav-link ${location.pathname === '/multischool/dashboard' ? 'active' : ''}`}>
								<img src="/images/menus/home.svg" alt="Icono Mi Perfil" className='me-3'/>
								{t('menus.home')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Link to="/multischool/profile" className={`nav-link ${location.pathname === '/multischool/profile' ? 'active' : ''}`}>
								<img src="/images/menus/user.svg" alt="Icono Mi Perfil" className='me-3' />
								{t('menus.profile')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Link to="/multischool/schools" className={`nav-link ${isSchoolsManagementActive(location.pathname) ? 'active' : ''}`}>
								<img src="/images/menus/experiencia.svg" alt="Centros" className='me-3' />
								{t('menus.schools')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Accordion defaultActiveKey="0">
								<Accordion.Item eventKey="0" className="ps-1">
									<Accordion.Header>
										<img src="/images/config.svg" alt="Icono Mi Perfil" className='me-3'/>
										{t('menus.processes')}
									</Accordion.Header>
									<Accordion.Body>
										<Nav defaultActiveKey="/config" className="flex-column">
											{/* <Nav.Item>
												<Link to="/multischool/startprocess" className={`nav-link ${location.pathname === '/multischool/startprocess' ? 'active' : ''}`}>
													{t('menus.startprocess')}
												</Link>
											</Nav.Item> */}
											<Nav.Item>
												<Link to="/multischool/programprocess" className={`nav-link ${location.pathname === '/multischool/programprocess' ? 'active' : ''}`}>
													{t('menus.programprocess')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link to="/multischool/activeprocesses" className={`nav-link ${isactiveProcessesActive(location.pathname) ? 'active' : ''}`}>
													{t('menus.activeprocesses')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link to="/multischool/completedprocesses" className={`nav-link ${location.pathname === '/multischool/completedprocesses' ? 'active' : ''}`}>
													{t('menus.completedprocesses')}
												</Link>
											</Nav.Item>
										</Nav>
									</Accordion.Body>
								</Accordion.Item>
							</Accordion>
						</Nav.Item>
						<Nav.Item>
							<Link to="/multischool/database/favourites" className={`nav-link ${location.pathname === '/multischool/database/favourites' || location.pathname === '/multischool/database/blocked' ? 'active' : ''}`}>
								<img src="/images/menus/database.svg" alt="Data base" className='me-3'/>
								{t('menus.database')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Link to="/multischool/tickets" className='nav-link'>
								<img src="/images/menus/ticket.svg" alt="Tickets" className='me-3'/>
								{t('menus.tickets')}
							</Link>
						</Nav.Item>
					</Nav>
				</Col>
			</Row>
			<Row>
				<Col className='text-center my-3'>
					<Version />
				</Col>
			</Row>
		</>
	)
}